import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLMEUserOperations extends Layout {
    labelAdditionalProfiles: Label;
    labelBrokeragePlanningProfiles: Label;
    labelCustomerServiceProfiles: Label;
    labelDriverManagerProfiles: Label;
    labelOrderEntryDefaults: Label;
    labelOrderPlanningProfiles: Label;
    labelTenderExpressProfile: Label;
    panelAdditionalProfiles: Panel;
    panelBpProfiles: Panel;
    panelCustomerServiceProfiles: Panel;
    panelDriverManagerProfiles: Panel;
    panelOrderEntryDefaults: Panel;
    panelOrderPlanningProfiles: Panel;
    panelTenderExpressProfile: Panel;
    sourceUserSettings: DataSource;
    textboxAssetOrderNextAction: Textbox;
    textboxBpProfile2: Textbox;
    textboxBpProfile3: Textbox;
    textboxBpProfile4: Textbox;
    textboxBpProfile: Textbox;
    textboxBrokerageOrderNextAction: Textbox;
    textboxCarrierSalesProfile: Textbox;
    textboxCustomerServiceProfile2: Textbox;
    textboxCustomerServiceProfile3: Textbox;
    textboxCustomerServiceProfile4: Textbox;
    textboxCustomerServiceProfile: Textbox;
    textboxDefMoveType: Textbox;
    textboxDefaultDispatchLayout: Textbox;
    textboxDefaultDistanceMarginPercentage: Textbox;
    textboxDefaultWirecode: Textbox;
    textboxDetentionProfileId: Textbox;
    textboxDriverManagerProfile2: Textbox;
    textboxDriverManagerProfile3: Textbox;
    textboxDriverManagerProfile4: Textbox;
    textboxDriverManagerProfile: Textbox;
    textboxLtexpressProfId: Textbox;
    textboxMessageVisibility: Textbox;
    textboxOperationsUserId: Textbox;
    textboxOptInDefault: Textbox;
    textboxOrderPlanningProfile2: Textbox;
    textboxOrderPlanningProfile3: Textbox;
    textboxOrderPlanningProfile4: Textbox;
    textboxOrderPlanningProfile: Textbox;
    textboxPartialShipmentProfile: Textbox;
    textboxQuickOfferDefault: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxSegAllocCode: Textbox;
    textboxSmsMessageLimit: Textbox;
    textboxTmProfile: Textbox;
}
